/* Sumo Supply theme behaviour.

   Same UI as the static build, but the cart is Shopify's. Line items come from
   /cart.js, quantity changes go through /cart/change.js, and Checkout hands off
   to Shopify's real checkout. The discount code is not applied here — it is a
   real code created in Discounts and entered at checkout.

   Nodes are built with createElement/textContent, never innerHTML. */
(function () {
  "use strict";

  var CFG = window.SUMO || {};
  var CART_URL = CFG.cartUrl || "/cart";

  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }

  function h(tag, props, children) {
    var el = document.createElement(tag);
    if (props) {
      Object.keys(props).forEach(function (k) {
        if (k === "class") el.className = props[k];
        else if (k === "text") el.textContent = props[k];
        else if (k.indexOf("on") === 0 && typeof props[k] === "function") el[k] = props[k];
        else if (props[k] != null) el.setAttribute(k, props[k]);
      });
    }
    (children || []).forEach(function (c) {
      if (c == null) return;
      el.appendChild(typeof c === "string" ? document.createTextNode(c) : c);
    });
    return el;
  }

  function money(cents) {
    return "$" + (cents / 100).toFixed(2);
  }

  /* ---------------- cart ---------------- */

  function scaffold() {
    if ($("#sumoCart")) return;

    var back = h("div", { class: "sumo-cart-backdrop", id: "sumoCartBack", onclick: closeCart });
    var drawer = h("aside", { class: "sumo-cart", id: "sumoCart", "aria-label": "Cart" }, [
      h("div", { class: "sumo-cart-head" }, [
        h("h3", { text: "Your cart" }),
        h("button", { class: "sumo-modal-close", "aria-label": "Close cart", onclick: closeCart }, ["×"])
      ]),
      h("div", { class: "sumo-cart-items", id: "sumoCartItems" }),
      h("div", { class: "sumo-cart-foot" }, [
        h("div", { id: "sumoTotals" }),
        h("button", {
          class: "sumo-btn", style: "margin-top:14px", text: "Checkout",
          onclick: function () { window.location.href = "/checkout"; }
        }),
        h("p", {
          class: "sumo-cart-note",
          text: CFG.promoCode ? "Use code " + CFG.promoCode + " at checkout." : ""
        })
      ])
    ]);

    document.body.appendChild(back);
    document.body.appendChild(drawer);
    document.body.appendChild(h("div", { class: "sumo-toast", id: "sumoToast" }));
  }

  function openCart() { scaffold(); $("#sumoCart").classList.add("open"); $("#sumoCartBack").classList.add("open"); }
  function closeCart() {
    var c = $("#sumoCart");
    if (!c) return;
    c.classList.remove("open");
    $("#sumoCartBack").classList.remove("open");
  }

  var toastTimer;
  function toast(msg) {
    scaffold();
    var t = $("#sumoToast");
    t.textContent = msg;
    t.classList.add("show");
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.classList.remove("show"); }, 2200);
  }

  function getCart() {
    return fetch("/cart.js", { headers: { Accept: "application/json" } }).then(function (r) { return r.json(); });
  }

  function changeLine(key, qty) {
    return fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); }).then(renderCart);
  }

  function lineItem(item) {
    return h("div", { class: "sumo-line-item" }, [
      h("img", { src: item.image ? item.image.replace(/(\.[a-z]+)(\?|$)/i, "_200x$1$2") : "", alt: "" }),
      h("div", { class: "sumo-li-main" }, [
        h("p", { class: "sumo-li-title", text: item.product_title }),
        h("div", { class: "sumo-li-price", text: money(item.final_line_price) }),
        h("div", { class: "sumo-qty" }, [
          h("button", {
            type: "button", "aria-label": "Decrease quantity",
            onclick: function () { changeLine(item.key, item.quantity - 1); }
          }, ["−"]),
          h("span", { text: String(item.quantity) }),
          h("button", {
            type: "button", "aria-label": "Increase quantity",
            onclick: function () { changeLine(item.key, item.quantity + 1); }
          }, ["+"])
        ]),
        h("button", {
          class: "sumo-li-remove", text: "Remove",
          onclick: function () { changeLine(item.key, 0); }
        })
      ])
    ]);
  }

  function renderCart(cart) {
    scaffold();
    var box = $("#sumoCartItems");
    box.textContent = "";

    if (!cart || !cart.items || !cart.items.length) {
      box.appendChild(h("p", { class: "sumo-cart-empty", text: "Your cart is empty." }));
    } else {
      cart.items.forEach(function (i) { box.appendChild(lineItem(i)); });
    }

    var tot = $("#sumoTotals");
    tot.textContent = "";
    tot.appendChild(h("div", { class: "sumo-total-row grand" }, [
      h("span", { text: "Subtotal" }),
      h("span", { text: money(cart ? cart.total_price : 0) })
    ]));

    var count = cart ? cart.item_count : 0;
    $$("[data-cart-count]").forEach(function (b) {
      b.textContent = String(count);
      b.classList.toggle("show", count > 0);
    });
    return cart;
  }

  /* Intercept add-to-cart forms so we stay on the page and open the drawer. */
  function bindAddForms() {
    $$("form[action$='/cart/add']").forEach(function (form) {
      form.addEventListener("submit", function (e) {
        e.preventDefault();
        var btn = form.querySelector("[name='add']");
        if (btn) btn.disabled = true;
        fetch("/cart/add.js", { method: "POST", body: new FormData(form) })
          .then(function (r) { return r.json(); })
          .then(function (res) {
            if (res.status) { toast(res.description || "Could not add that item"); return; }
            toast((res.product_title || "Item") + " added to cart");
            return getCart().then(renderCart).then(openCart);
          })
          .catch(function () { toast("Could not add that item"); })
          .finally(function () { if (btn) btn.disabled = false; });
      });
    });
  }

  /* ---------------- promo popup ---------------- */
  function popup() {
    if (!CFG.promoEnabled || !CFG.promoCode) return;
    var KEY = "sumo.popup.seen.v1";
    try { if (localStorage.getItem(KEY)) return; } catch (e) { return; }

    var overlay = h("div", { class: "sumo-modal", id: "sumoModal" });
    function dismiss() {
      try { localStorage.setItem(KEY, "1"); } catch (e) {}
      overlay.classList.remove("open");
      setTimeout(function () { overlay.remove(); }, 150);
    }

    var box = h("div", {
      class: "sumo-modal-box", role: "dialog", "aria-modal": "true", "aria-label": "Discount code"
    }, [
      h("button", { class: "sumo-modal-close", "aria-label": "Close", onclick: dismiss }, ["×"]),
      CFG.logo ? h("img", { src: CFG.logo, alt: "" }) : null,
      h("h2", { text: CFG.promoHeading || ("Take " + CFG.promoPercent + "% off your build") }),
      h("p", { text: CFG.promoBody || "Use this code at checkout." }),
      h("span", { class: "sumo-code", text: CFG.promoCode }),
      h("button", {
        class: "sumo-btn", text: CFG.promoCta || "Start shopping",
        onclick: function () {
          dismiss();
          var hero = document.getElementById("sumo-hero");
          if (hero) hero.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      }),
      h("button", { class: "sumo-modal-dismiss", text: "No thanks, keep browsing", onclick: dismiss })
    ]);

    overlay.appendChild(box);
    overlay.onclick = function (e) { if (e.target === overlay) dismiss(); };
    document.body.appendChild(overlay);
    requestAnimationFrame(function () { overlay.classList.add("open"); });
  }

  /* ---------------- gallery ---------------- */
  function gallery() {
    var stage = $("#sumoStageImg");
    if (!stage) return;
    var thumbs = $$(".sumo-thumb");
    thumbs.forEach(function (t) {
      t.addEventListener("click", function () {
        stage.setAttribute("src", t.getAttribute("data-full"));
        thumbs.forEach(function (o) { o.setAttribute("aria-selected", "false"); });
        t.setAttribute("aria-selected", "true");
      });
    });
  }

  /* ---------------- header menus ---------------- */
  function headerLinks() {
    var seen = {};
    return $$("header a[href]").filter(function (a) {
      var href = a.getAttribute("href") || "";
      var text = (a.textContent || "").trim();
      if (!text || a.querySelector("img") || href === "#") return false;
      if (seen[href + text]) return false;
      seen[href + text] = 1;
      return true;
    }).map(function (a) { return { href: a.getAttribute("href"), text: a.textContent.trim() }; });
  }

  function mobileMenu() {
    var btn = document.querySelector('[aria-label="Open menu"]');
    if (!btn) return;
    var back = h("div", { class: "sumo-drawer-back", id: "sumoDrawerBack" });
    var drawer = h("aside", { class: "sumo-drawer", id: "sumoDrawer", "aria-label": "Menu" });
    function close() { drawer.classList.remove("open"); back.classList.remove("open"); }
    back.onclick = close;

    drawer.appendChild(h("div", { class: "sumo-drawer-head" }, [
      CFG.logo ? h("img", { class: "sumo-drawer-logo", src: CFG.logo, alt: "" }) : h("span"),
      h("button", { class: "sumo-modal-close", "aria-label": "Close menu", onclick: close }, ["×"])
    ]));
    headerLinks().forEach(function (l) {
      drawer.appendChild(h("a", { href: l.href, text: l.text }));
    });

    document.body.appendChild(back);
    document.body.appendChild(drawer);
    btn.addEventListener("click", function (e) {
      e.preventDefault();
      drawer.classList.add("open");
      back.classList.add("open");
    });
  }

  function search() {
    var btn = document.querySelector('[aria-label="Search"]');
    if (!btn) return;
    var input = h("input", { type: "search", name: "q", placeholder: "Search wheels, brakes, tires…", "aria-label": "Search products" });
    var form = h("form", { class: "sumo-search-box", action: "/search", method: "get", role: "search" }, [input]);
    var wrap = h("div", { class: "sumo-search-wrap", id: "sumoSearch" }, [form]);
    document.body.appendChild(wrap);

    btn.addEventListener("click", function (e) {
      e.preventDefault();
      wrap.classList.add("open");
      input.focus();
    });
    wrap.addEventListener("click", function (e) { if (e.target === wrap) wrap.classList.remove("open"); });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") wrap.classList.remove("open");
    });
  }

  function bindCartToggle() {
    $$("[data-sumo-cart-toggle], [aria-label='Cart']").forEach(function (b) {
      b.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        getCart().then(renderCart).then(openCart);
      });
    });
  }

  function init() {
    scaffold();
    bindAddForms();
    bindCartToggle();
    gallery();
    mobileMenu();
    search();
    getCart().then(renderCart).catch(function () {});
    popup();
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
})();
